export let stringOperators = [
  {
    label: 'Matches',
    value: '$eq'
  },
  {
    label: 'Contains',
    value: 'contains'
  },
  {
    label: 'Does not match',
    value: '$ne'
  },
  {
    label: 'Does not contain',
    value: '$not'
  }
]

export let basicOperators = [
  {
    label: 'Matches',
    value: '$eq'
  },
  {
    label: 'Does not match',
    value: '$ne'
  }
]

export let taxonomyTermOperators = [
  {
    label: 'Matches',
    value: '$in'
  },
  {
    label: 'Does not match',
    value: '$nin'
  }
]

export let comparisonOperator = [
  {
    label: 'Equals',
    value: '$eq'
  },
  {
    label: 'Is lesser than and equals',
    value: '$lte'
  },
  {
    label: 'Is greater than and equals',
    value: '$gte'
  }
]

export let allOperators = [
  {
    label: 'Equals',
    value: '$eq'
  },
  {
    label: 'Not equals',
    value: '$ne'
  },
  {
    label: 'Is lesser than and equals',
    value: '$lte'
  },
  {
    label: 'Is greater than and equals',
    value: '$gte'
  },
  {
    label: 'Is lesser than',
    value: '$lt'
  },
  {
    label: 'Is greater than',
    value: '$gt'
  }
]

export const grpHeadingTextArr = ['System-defined Fields', 'User-defined Fields']

export const modules = [
  { label: 'Entries', value: 'entries' },
  { label: 'Assets', value: 'assets' }
]

export const modulesById = {
  entries: 'Entries',
  assets: 'Assets'
}

export const notPublishedEnvObj = { label: 'Not Published', value: '_notPublished_env' }

export const advanceQueryOpts = [
  { label: 'Match Any Conditions', value: 'matchAny' },
  { label: 'Match All Conditions', value: 'matchAll' }
]

export const operatorByValue = {
  $eq: {
    label: 'Matches',
    value: '$eq'
  },
  contains: {
    label: 'Contains',
    value: 'contains'
  },
  $ne: {
    label: 'Does not match',
    value: '$ne'
  },
  $lte: {
    label: 'Is lesser than and equals',
    value: '$lte'
  },
  $gte: {
    label: 'Is greater than and equals',
    value: '$gte'
  },
  $regex: {
    label: 'Contains',
    value: 'contains'
  },
  $lt: {
    label: 'Is lesser than',
    value: '$lt'
  },
  $gt: {
    label: 'Is greater than',
    value: '$gt'
  },
  $exists: {
    label: 'Is empty',
    value: '$exists'
  },
  $in: {
    label: 'Matches',
    value: '$eq'
  },
  $nin: {
    label: 'Does not match',
    value: '$ne'
  },
  $localization: { label: 'Localized In', value: '$localization' },
  $notLocalization: { label: 'Not Localized In', value: '$notLocalization' },
  $not: {
    label: 'Does not contain',
    value: '$not'
  }
}

export const usersKey = ['created_by', 'updated_by', '_published_by']
export const dateKey = ['created_at', 'updated_at', '_published_at']
export const environmentKey = '_publish_environment'
export const contentTypeKey = '_content_type_uid'
export const termKey = 'taxonomies'
export const languageKey = 'locale'
export const tagKey = 'tags'
export const fileNameKey = 'filename'
export const fileSizeKey = 'file_size'
export const urlKey = 'url'
export const titleKey = 'title'
export const assetTypeKey = '_content_type_uid'
export const uidKey = 'uid'
export const workflowStageKey = '_workflow'
export const advSearchTextLabelKey = 'search'

export const commonQueryFormat = {
  _publish_environment: {
    key: [{ label: 'Published Environment', value: '_publish_environment' }],
    operator: [],
    value: [],
    queryType: 'environmentLabel'
  },
  _published_at: {
    key: [{ label: 'Published At', value: '_published_at' }],
    operator: [],
    value: [],
    queryType: 'dateLabel'
  },
  _published_by: {
    key: [{ label: 'Published By', value: '_published_by' }],
    operator: [],
    value: [],
    queryType: 'userLabel'
  },
  updated_at: {
    key: [{ label: 'Updated At', value: 'updated_at' }],
    operator: [],
    value: [],
    queryType: 'dateLabel'
  },
  updated_by: {
    key: [{ label: 'Updated By', value: 'updated_by' }],
    operator: [],
    value: [],
    queryType: 'userLabel'
  },
  created_at: {
    key: [{ label: 'Created At', value: 'created_at' }],
    operator: [],
    value: [],
    queryType: 'dateLabel'
  },
  created_by: {
    key: [{ label: 'Created By', value: 'created_by' }],
    operator: [],
    value: [],
    queryType: 'userLabel'
  },
  uid: {
    key: [{ label: 'UID', value: 'uid' }],
    operator: [],
    value: [],
    queryType: 'uidLabel'
  },
  search: {
    key: [{ label: 'Text', value: 'search' }],
    operator: [{ label: 'Contains', value: 'contains' }],
    value: [],
    queryType: 'advSearchTextLabel'
  }
}
